module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7mPI8"))).then(() => parcelRequire('hEqeo'));